<template>
	<div id="app">
		<datav />
	</div>
</template>

<script>
	import datav from './view/index.vue'

	export default {
		name: 'app',
		components: {
			datav
		},
		data() {
			return {}
		},
		created() {
			this.resizeWidth()
		},
		mounted() {
			window.onresize = () => {
				return (() => {
					this.resizeWidth()
					// location.reload()
				})();
			};
		},
		methods: {
			resizeWidth() {
				/* let height = window.screen.height
				let width = window.screen.width */
				
				let innerHeight = window.innerHeight
				let innerWidth = window.innerWidth
				
				let winWidth,winHeight;
				// 获取窗口宽度
				if (window.innerWidth)
					winWidth = window.innerWidth;
				else if ((document.body) && (document.body.clientWidth))
					winWidth = document.body.clientWidth;
				// 获取窗口高度
				if (window.innerHeight)
					winHeight = window.innerHeight;
				else if ((document.body) && (document.body.clientHeight))
					winHeight = document.body.clientHeight;
				// 通过深入 Document 内部对 body 进行检测，获取窗口大小
				if (document.documentElement && document.documentElement.clientHeight && document.documentElement.clientWidth)
				{
					winHeight = document.documentElement.clientHeight;
					winWidth = document.documentElement.clientWidth;
				}

				var ratio = winWidth / 1920;
				console.log(ratio)
				
				document.body.style.transform = "scale(" + ratio + ")"
				document.body.style.transformOrigin = "left top"
				document.body.style.backgroundSize = "100%"

				/* $('body').css({
					transform: "scale(" + ratio + ")",
					transformOrigin: "left top",
					backgroundSize: "100%"
				}); */
			}
		}
	}
</script>

<style lang="less">
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
		width: 100%;
		height: 100%;
	}
</style>
